module.exports = __webpack_public_path__ + "img/product_6.9acf767b.jpg";